export default __webpack_public_path__ + "af4c863a0acf551eadf55c0e7bbd46a3.png";